import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
export default [{
  path: '/user/home',
  name: ROUTE_NAME.USER_HOME,
  meta: {
    title: '我的',
    needBinding: true,
    disableShare: true,
    popup: 'countdown',
    needLoginNext: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/home.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/info',
  name: ROUTE_NAME.USER_INFO,
  meta: {
    title: '我的',
    needBinding: true,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/info.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/withdraw_info',
  name: ROUTE_NAME.USER_WITHDRAW_INFO,
  meta: {
    title: '管理提现',
    needBinding: true,
    disableShare: false
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/withdrawInfo.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/withdraw_account',
  name: ROUTE_NAME.USER_WITHDRAW_ACCOUNT,
  meta: {
    title: '管理提现',
    needBinding: true,
    disableShare: false
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/withdrawAccount.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/wallet/:activityId?',
  name: ROUTE_NAME.USER_WALLET,
  meta: {
    title: '我的钱包',
    needBinding: true,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/wallet.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/wallet/convertcoin/index',
  name: ROUTE_NAME.USER_CONVERTCOIN,
  meta: {
    title: '我的钱包',
    needBinding: true,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/convertCoin.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/coin_withdraw',
  name: ROUTE_NAME.COIN_WITHDRAW,
  meta: {
    title: '提现',
    disableShare: true,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/coinWithdraw.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/coin_detail',
  name: ROUTE_NAME.COIN_TALLY,
  meta: {
    title: '明细',
    disableShare: true,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/coinDetail.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/coin_index',
  name: ROUTE_NAME.COIN_INDEX,
  meta: {
    title: '明细',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/coinIndex.vue');
  }
}, {
  path: '/user/coin_task',
  name: ROUTE_NAME.COIN_TASK,
  meta: {
    title: '明细',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/coinTask.vue');
  }
}, {
  path: '/user/coin_withdraw_account',
  name: ROUTE_NAME.COIN_WITHDRAW_ACCOUNT,
  meta: {
    title: '提现',
    disableShare: true,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/coinWithdrawAccount.vue'),
      loading: Loading
    };
  }
}, // {
//     path: '/user/account_withdraw',
//     name: ROUTE_NAME.USER_ACCOUNT_WITHDRAW,
//     meta: {
//         title: '余额提现',
//         disableShare: true,
//         needBinding: true,
//     },
//     component: () => ({
//         component: import(/* webpackChunkName: "user" */ '@/pages/user/accountWithdraw.vue'),
//         loading: Loading,
//     }),
// },
{
  path: '/user/phone_binding/:routeTo?',
  name: ROUTE_NAME.USER_PHONE_BINDING,
  meta: {
    title: '手机绑定',
    auth: false,
    scrollBehavior: 'top',
    blockPlatform: ['web']
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/phoneBinding.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/phone_login',
  name: ROUTE_NAME.USER_PHONE_LOGIN,
  meta: {
    title: '登录',
    auth: false,
    blockPlatform: ['weixin']
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/phoneLogin.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/notification',
  name: ROUTE_NAME.USER_NOTIFICATION,
  meta: {
    title: '消息通知',
    disableShare: true,
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/notification.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/credit_points',
  name: ROUTE_NAME.USER_CREDIT_POINTS,
  meta: {
    title: '我的信用分',
    disableShare: true,
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/creditPoints.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/setting',
  name: ROUTE_NAME.USER_SETTING,
  meta: {
    title: '打卡设置',
    disableShare: true,
    needLogin: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "user" */
      '@/pages/user/setting.vue'),
      loading: Loading
    };
  }
}, {
  path: '/user/center/:userId',
  name: ROUTE_NAME.USER_CENTER,
  meta: {
    title: '个人主页',
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/otherHome.vue');
  }
}, {
  path: '/user/other_signin',
  name: ROUTE_NAME.OTHER_SIGNIN,
  meta: {
    title: '替Ta报名',
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/other.vue');
  }
}, {
  path: '/user/other_signin_cancel/:id/:activityId?',
  name: ROUTE_NAME.OTHER_SIGNIN_CANCEL,
  meta: {
    title: '打卡情况',
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/otherSignin.vue');
  }
}, {
  path: '/user/other_withdraws',
  name: ROUTE_NAME.WIDTHDRAW_LIST,
  meta: {
    title: '明细',
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/withdraws.vue');
  }
}, {
  path: '/user/follow_fan/:type',
  name: ROUTE_NAME.USER_FOLLOW_FAN,
  meta: {
    title: function title(to) {
      return to.params.type === 'follow' ? '我的关注' : '我的粉丝';
    },
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/followFanList.vue');
  }
}, {
  path: '/user/third_plat',
  name: ROUTE_NAME.USER_THIRD_PLAT,
  meta: {
    title: '跑步软件账号绑定',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "user" */
    '@/pages/user/thirdPlat.vue');
  }
}];